export default "__VITE_ASSET__BULgp4Vc__"